import { useMutation, useQuery } from "react-query";
import { getSecurityForEdit } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetSecurityForEdit = () => {
  return useMutation(getSecurityForEdit);
};


